import { render, staticRenderFns } from "./EmailConfirmation.vue?vue&type=template&id=dc9241da&"
import script from "./emailConfirmation.js?vue&type=script&lang=js&"
export * from "./emailConfirmation.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports